import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';

export default class TSKoerperschaftDaten extends TSAbstractEntity implements TSSerializable<TSKoerperschaftDaten> {

    private _koerperschaftArt: string;

    public get koerperschaftArt(): string {
        return this._koerperschaftArt;
    }

    public set koerperschaftArt(value: string) {
        this._koerperschaftArt = value;
    }

    deserialize(restObject: any): TSKoerperschaftDaten {
        super.deserialize(restObject);
        this.koerperschaftArt = restObject.koerperschaftArt;
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.koerperschaftArt = this.koerperschaftArt;
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSKoerperschaftDaten.ts